var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossTickSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 35.9952C15.7937 35.9952 13.6091 35.5486 11.5709 34.6808C9.5326 33.8131 7.68058 32.5413 6.12056 30.9379C4.56053 29.3345 3.32305 27.4311 2.47878 25.3362C1.6345 23.2413 1.19995 20.996 1.19995 18.7285C1.19995 16.461 1.6345 14.2157 2.47878 12.1209C3.32305 10.026 4.56053 8.1225 6.12056 6.51914C7.68058 4.91578 9.5326 3.64393 11.5709 2.7762C13.6091 1.90847 15.7937 1.46185 18 1.46185C22.4556 1.46185 26.7287 3.28101 29.8793 6.51914C33.03 9.75727 34.7999 14.1491 34.7999 18.7285C34.7999 23.3079 33.03 27.6998 29.8793 30.9379C26.7287 34.176 22.4556 35.9952 18 35.9952Z",
    stroke: "white",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.839 18.7285L25.2 25.2758L24.3703 26.1285L18 19.5907L11.6298 26.1285L10.8 25.2758L17.1611 18.7285L10.8 12.1813L11.6298 11.3285L18 17.8663L24.3703 11.3285L25.2 12.1813L18.839 18.7285Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 37,
    fill: "white",
    transform: "translate(0 0.228516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossTickSvg);
export default __webpack_public_path__ + "static/media/cross_tick_svg.af01e3b97fa8666e24af076d396dc799.svg";
export { ForwardRef as ReactComponent };